/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ElectricalToolbeltComponent } from './electrical-toolbelt.component';
import { SwitchWithLabelVModule } from '../switch-with-label-v/switch-with-label-v.module';
import { ShiftSegmentModule } from '../shift-segment/shift-segment.module';
import { RotateElementModule } from '../rotate-element/rotate-element.module';

@NgModule({
  declarations: [ElectricalToolbeltComponent],
  imports: [CommonModule, SwitchWithLabelVModule, ShiftSegmentModule, RotateElementModule],
  exports: [ElectricalToolbeltComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ElectricalToolbeltModule {}
